import { Outlet } from 'react-router'

const SummaryLayoutNew = () => {
  return (
    <Outlet />
  )
}

export default SummaryLayoutNew